export type FmntsExpansionPanelState = 'expanded' | 'collapsed';

export type ExpansionTogglePosition = 'before' | 'after';
export type ExpansionHeaderPosition = 'before' | 'after';

export function getExpandedState(value: boolean): FmntsExpansionPanelState {
  return value ? 'expanded' : 'collapsed';
}
